import React from 'react';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import classNames from 'classnames';
import EditableRTECell from 'main/components/show/cuesheet/editableRTECell.jsx';
import HighlightCellMixin from 'main/components/show/cuesheet/highlightCellMixin';
import HighlightCellHelper from 'main/components/show/cuesheet/highlightCellHelper';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import FDTPropUpdateFixMixin from 'main/components/show/cuesheet/FDTPropUpdateFixMixin';
import CellHistoryIcon from 'main/components/show/cuesheet/cellHistoryIcon.jsx';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import { Map } from 'immutable';
import { getDefaultRTEState } from 'shared/lib/rteHelper';

/**
 * Data cell
 *
 */
export default React.createClass({
  displayName: 'DataCell',

  mixins: [PureRenderMixin, HighlightCellMixin, FDTPropUpdateFixMixin],

  propTypes: {
    item: React.PropTypes.object.isRequired,
    cell: React.PropTypes.object,
    columnId: React.PropTypes.string.isRequired,
    isEditing: React.PropTypes.bool,
    isSelected: React.PropTypes.bool,
    isCopied: React.PropTypes.bool,
    rowIndex: React.PropTypes.number.isRequired,
    rowId: React.PropTypes.string.isRequired,
    height: React.PropTypes.number,
    corrupted: React.PropTypes.bool,
  },

  render() {
    const {
      isCopied,
      isSelected,
      isEditing,
      cell,
      rowIndex,
      rowId,
      columnId,
      width,
      height,
      collabCell,
    } = this.props;

    const wrapperClasses = 'cs-data-cell-wrapper';

    const cellClasses = classNames(
      'cs-data-cell',
      { 'cs-cell-copied': isCopied },
      this.getPersonalHighlightClass(),
    );

    let historyNode = null;

    const cellSpec = Map({ type: EditableCellTypes.Data, value: columnId });

    if (isSelected && !isEditing) {
      historyNode = (
        <span data-testid={`history-icon-${columnId}-${rowId}`}>
          <CellHistoryIcon
            onClick={() =>
              CuesheetCellActions.showCellHistory(rowIndex, cellSpec)
            }
          />
        </span>
      );
    }

    return (
      <div className={wrapperClasses} data-testid="data-cell">
        {historyNode}
        <EditableRTECell
          keyPrefix={'row-' + rowId + '-' + columnId + '-data'}
          width={width}
          height={height}
          format={cell ? cell.get('format') : null}
          onSelect={this._select}
          onStartEdit={this._startEditing}
          onStopEdit={this._stopEditing}
          rteState={this._getCellState()}
          resizeWhenEditing
          extraClassName={cellClasses}
          collabCell={collabCell}
          style={Object.assign(
            {},
            this.getGlobalHighlightStyle(),
            this.getPersonalHighlightStyle(),
            HighlightCellHelper.getCollabBorderStyle(collabCell),
          )}
          {...this.props}
        />
      </div>
    );
  },

  _getCellState() {
    const { cell } = this.props;

    if (!cell) return getDefaultRTEState();

    return cell.get('rteState');
  },

  _select() {
    const { rowIndex, columnId } = this.props;
    CuesheetCellActions.selectDataCell(rowIndex, columnId);
  },

  _startEditing() {
    const { rowIndex, columnId } = this.props;
    CuesheetCellActions.startEditingDataCell(rowIndex, columnId);
  },

  _stopEditing(rteState, rowId) {
    const { columnId } = this.props;

    const cellSpec = Map({ type: EditableCellTypes.Data, value: columnId });

    //Why are we accessing rowIndex and columnId directly on "this"? Look at FDTPropUpdateFixMixin
    CuesheetCellActions.saveDataCellChanges(rowId, cellSpec, rteState);
  },
});
